/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PageEmailChangeLogDto } from '../model';
/**
 * AdminEmailChangeLogControllerApi - axios parameter creator
 * @export
 */
export const AdminEmailChangeLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmailChanges: async (patientId?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/email-changes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (patientId !== undefined) {
                localVarQueryParameter['patientId'] = patientId;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEmailChangeLogControllerApi - functional programming interface
 * @export
 */
export const AdminEmailChangeLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEmailChangeLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllEmailChanges(patientId?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<PageEmailChangeLogDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllEmailChanges(patientId, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminEmailChangeLogControllerApi - factory interface
 * @export
 */
export const AdminEmailChangeLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEmailChangeLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [patientId] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllEmailChanges(patientId?: number, search?: string, options?: any): Promise<PageEmailChangeLogDto> {
            return localVarFp.getAllEmailChanges(patientId, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEmailChangeLogControllerApi - object-oriented interface
 * @export
 * @class AdminEmailChangeLogControllerApi
 * @extends {BaseAPI}
 */
export class AdminEmailChangeLogControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [patientId] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEmailChangeLogControllerApi
     */
    public getAllEmailChanges(patientId?: number, search?: string, options?: AxiosRequestConfig) {
        return AdminEmailChangeLogControllerApiFp(this.configuration).getAllEmailChanges(patientId, search, options).then((request) => request(this.axios, this.basePath));
    }
}
